module.exports = __webpack_public_path__ + "img/banner-after.b5bd7e22.webp";